
    import {useStore} from "@/store";
    import {useRouter} from "vue-router";
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";
    
    interface Photo {
        photoIdStr: string;
        smallPhotoUrl: string;
        photoName: string;
    }

    interface State {
        photoList: Array<Photo>;
        slideIndex: number;
        bannerSwiper: object;
        photoLength: number;
        isShowModel: boolean;
    }
    
    export default defineComponent({
        name: "reportResult",
        setup() {
            let state: State = reactive({
                photoList: [],
                slideIndex: 0,
                bannerSwiper: {},
                photoLength: 0,
                isShowModel: false
            })
            const store = useStore()
            // 获取路由器实例
            const router = useRouter()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {photoList} = data;
                state.photoList = photoList; // [...photoList,...markPhotoList,...paintPhotoList, ...defectPhotoList];
                state.photoLength = photoList.length;
                                    // +
                                    // (markPhotoList ? markPhotoList.length : 0) +
                                    // (paintPhotoList ? paintPhotoList.length : 0) +
                                    // (defectPhotoList ? defectPhotoList.length : 0);
            })
            return {
                state,
                router
            }
        },
        methods: {
            showModel() {
                this.state.isShowModel = true
                document.body.style.overflow = "hidden" 
            },
            hiddenModel(){
                this.state.isShowModel = false
                document.body.style.overflow = "" 
            },
            goPhoto(item, isAll){
                this.router.push({
                    path: '/idlefishPhotoList',
                    name: 'idlefish-PhotoList',
                    query: {
                        isAll,
                        item: JSON.stringify(item)
                    }
                })
            },
            goIntroduce(){
                this.router.push({
                    path:'/idlefishIntroduction'
                })
            }
        }
    })
